export default "__VITE_ASSET__65a3d2c7__"